/*
 * author: nick.arcuri@spartan.com
 * date: 07/15/2020
 *
 * this module pulls data from the Contentful API to populate the
 * shop navigation menu and the footer links menu
 *
 * CONTENTFUL_ACCESS_TOKEN, CONTENTFUL_SPACE_ID, and NAVIGATION_CONTENTFUL_ENTRY_ID
 * are all defined via the webpack.DefinePlugin as environment variables
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createClient } from 'contentful';
import { internationalSingleton } from './International';
import MainNav from '../tsx/MainNav';
import Footer from '../tsx/Footer';
function ExternalNavigation() {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var navData, contentfulClient, contentfulParams, data, err_1, contentfulParams, data, components, footer, mobileFooter, replacedEl, replacedElParent, error_1, mainNav, mobileNav;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(!process.env.CONTENTFUL_SPACE_ID ||
                        !process.env.CONTENTFUL_ACCESS_TOKEN)) return [3 /*break*/, 1];
                    navData = parseDefaultData();
                    return [3 /*break*/, 10];
                case 1:
                    contentfulClient = createClient({
                        space: process.env.CONTENTFUL_SPACE_ID,
                        accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
                        environment: (_a = process.env.CONTENTFUL_ENV) !== null && _a !== void 0 ? _a : 'master',
                    });
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, internationalSingleton.asyncInit];
                case 3:
                    _d.sent();
                    contentfulParams = {
                        include: 6,
                        locale: internationalSingleton.countryCode,
                    };
                    return [4 /*yield*/, contentfulClient.getEntry(process.env.NAVIGATION_CONTENTFUL_ENTRY_ID, contentfulParams)];
                case 4:
                    data = _d.sent();
                    navData = (_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.components;
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _d.sent();
                    console.error(err_1);
                    return [3 /*break*/, 6];
                case 6:
                    _d.trys.push([6, 9, , 10]);
                    return [4 /*yield*/, internationalSingleton.asyncInit];
                case 7:
                    _d.sent();
                    contentfulParams = {
                        include: 6,
                        locale: internationalSingleton.countryCode,
                    };
                    return [4 /*yield*/, contentfulClient.getEntry(process.env.FOOTER_CONTENTFUL_ENTRY_ID, contentfulParams)];
                case 8:
                    data = _d.sent();
                    console.log('FOOTER DATA: \n', JSON.stringify(data.fields.components, null, 4));
                    components = ((_c = data.fields) !== null && _c !== void 0 ? _c : {}).components;
                    if (components) {
                        footer = Footer(components);
                        mobileFooter = Footer(components, true);
                        replacedEl = document.querySelector('footer.site-footer .footer-mega .footer-wrapper .link-wrapper');
                        replacedElParent = replacedEl.parentNode;
                        replacedEl.replaceWith(footer);
                        replacedElParent.appendChild(mobileFooter);
                    }
                    return [3 /*break*/, 10];
                case 9:
                    error_1 = _d.sent();
                    console.error(error_1);
                    return [3 /*break*/, 10];
                case 10:
                    if (navData) {
                        console.log('NAVI: ', navData);
                        mainNav = MainNav(navData, false);
                        document.querySelector('.site-nav__wrap').replaceWith(mainNav);
                        mobileNav = MainNav(navData, true);
                        document
                            .querySelector('.mobile-nav-placeholder')
                            .replaceWith(mobileNav);
                    }
                    else {
                        console.warn('No navigation data returned');
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export default ExternalNavigation;
var parseNode = function (data, sysId) {
    return {
        fields: __assign({ text: "" + data.title }, (data.url ? { url: data.url } : {})),
        sys: {
            contentType: {
                sys: {
                    id: sysId,
                },
            },
        },
    };
};
function parseDefaultData() {
    return window.defaultNavData.links.map(function (l) {
        return {
            fields: {
                // Level 1
                text: l.title,
                components: l.links.map(function (lv2) { return ({
                    // Level 2, dropdown
                    fields: {
                        components: __spreadArray([
                            parseNode(lv2, 'componentLinkBig')
                        ], (lv2.links
                            ? lv2.links.map(function (l) {
                                return parseNode(l, 'componentLinkSmall');
                            })
                            : []), true),
                    },
                }); }),
            },
        };
    });
}
